(function () {
  function getCookie(name) {
    var needle = name + '=';
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(needle) === 0) return part.substring(needle.length);
    }
    return '';
  }

  function setCookie(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/;SameSite=Lax';
  }

  function parseLockData() {
    var node = document.querySelector('[data-content-lock-data]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function showError(errorEl) {
    if (!errorEl) return;
    errorEl.hidden = false;
    errorEl.classList.add('is-visible');
  }

  function hideError(errorEl) {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.classList.remove('is-visible');
  }

  function unlockPage(cookieName, days) {
    setCookie(cookieName, 'true', days || 6);
    document.documentElement.classList.remove('content-lock-active');
    window.location.reload();
  }

  function initGate(config) {
    var form = document.getElementById('ContentLockGateForm');
    var input = document.getElementById('ContentLockPassword');
    var expected = document.getElementById('ContentLockPasswordValue');
    var errorEl = document.getElementById('ContentLockError');
    if (!form || !input || !expected) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      hideError(errorEl);

      var entered = (input.value || '').trim().toUpperCase();
      var password = (expected.value || '').trim().toUpperCase();

      if (password && entered && entered === password) {
        unlockPage(config.cookie_name, config.cookie_days);
        return;
      }

      showError(errorEl);
      input.focus();
    });

    initSignupForm();
  }

  function initSignupForm() {
    var form = document.getElementById('ContentLockSignupForm');
    if (!form) return;

    var emailInput = document.getElementById('ContentLockSignupEmail');
    var consentInput = document.getElementById('ContentLockSignupConsent');
    var errorEl = document.getElementById('ContentLockSignupError');

    form.addEventListener('submit', function (event) {
      hideError(errorEl);

      var email = (emailInput && emailInput.value ? emailInput.value : '').trim();
      if (!email || email.indexOf('@') === -1) {
        event.preventDefault();
        showError(errorEl);
        if (emailInput) emailInput.focus();
        return;
      }

      if (consentInput && !consentInput.checked) {
        event.preventDefault();
        showError(errorEl);
        consentInput.focus();
        return;
      }

      // Allow normal POST to Ometria (api.ometria.com/forms/signup)
    });
  }

  function updateHeader(config) {
    var headerAnchor = document.querySelector('.header__heading-link, .header__logo a');
    if (!headerAnchor || !config.alternate_logo) return;

    var logo = headerAnchor.querySelector('img');
    if (!logo) return;
    logo.removeAttribute('srcset');
    logo.setAttribute('src', config.alternate_logo);
  }

  function init() {
    var parsed = parseLockData();
    if (!parsed || !parsed.data || !parsed.data.active) return;

    var config = parsed.data;
    config.cookie_name = config.cookie_name || 'content_lock';

    if (config.page_locked) {
      if (getCookie(config.cookie_name)) {
        document.documentElement.classList.remove('content-lock-active');
        updateHeader(config);
      } else {
        document.documentElement.classList.add('content-lock-active');
        initGate(config);
      }
      return;
    }

    if (getCookie(config.cookie_name)) updateHeader(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
